// Single source of truth for Signing Day. Change SIGNING_DAY to slide the whole event —
// the landing countdown, the gate, and the submission window all read from here.
// Default: ~4 weeks out (the "strive for 4" target). Swap the date when it's locked.
export const SIGNING_DAY = new Date('2026-07-28T20:00:00Z');
export const SIGNING_DAY_LABEL = 'July 28, 2026';
